import { classNames } from 'primereact/utils'
import styles from '../Homework.module.scss'
import { Button } from 'primereact/button'
import React, { FC, ReactElement, ReactNode } from 'react'
import { getStaticPath } from 'src/http'
import { Mark } from './Mark'
import { dayWorker } from 'src/utils'
import { dateFormatWithTime } from 'src/constants/constants'

export enum HomeworkCardStatuses {
    'Выполнено' = 'completed',
    'На проверке' = 'progress',
    'Не сделано' = 'notCompleted',
    'Просрочено' = 'over',
}

interface HomeworkCardProps {
    status: keyof typeof HomeworkCardStatuses;
    statusText: string;
    fullname: ReactNode;
    onClick: () => void;
    date: number | null;
    mark: number;
    avatar: string | null;
}

export const HomeworkCard: FC<HomeworkCardProps> = (props: HomeworkCardProps): ReactElement => {
    const {
        status,
        statusText,
        onClick,
        fullname,
        date,
        avatar,
        mark,
    } = props
    
    return (
        <div
            className={classNames(
                styles.homeWork,
                styles[HomeworkCardStatuses[status]],
            )}
        >
            <div className={styles.headerWrapper}>
                <div className={styles.header}>{statusText}</div>
                {date ? (
                    <div className={styles.date}>
                        {dayWorker(date).format(dateFormatWithTime)}
                    </div>
                ) : null}
            </div>
            <div className={styles.content}>
                <div className={'flex'}>
                    <img
                        className={styles.avatar}
                        src={`${getStaticPath()}/avatars/${avatar}`}
                        alt={'Аватар'}
                    />
                    <div className={styles.name}>{fullname}</div>
                </div>
                <div className={styles.buttons}>
                    <Button onClick={onClick}>
                        {status === 'Выполнено' ? 'Просмотреть' : 'Проверить'}
                    </Button>
                    {status === 'Выполнено' ? (
                        <Mark mark={mark} disabled />
                    ) : null}
                </div>
            </div>
        </div>
    )
}
